import { Tile } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import GnbNodesList from './GnbNodesList';

const GnbNodesPage = () => {
  return (
    <ReactEDSWrapper component={Tile} id="gnb-node-management" title="CR gNB Node Management" style={{ overflow: 'auto', height: 'calc(100vh - 100px)' }}>
      <GnbNodesList />
    </ReactEDSWrapper>
  );
};

export default GnbNodesPage;
